import { defineObstacle } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   NOYAU — le rocher DENSE, destructible mais tenace.

   Entre le Bloc (140 PV) et l'indestructible Colosse : 240 PV, soit ~1,2 s de
   tir soutenu de VULCAN. Assez pour qu'on hésite vraiment — le faire sauter
   immobilise le tir plus d'une seconde, une éternité au milieu d'un champ — sans
   pour autant devenir un mur qu'aucune arme n'entame. Sa fonction est de DENSIFIER
   les champs des mondes tardifs : là où le Bloc s'ouvre presque tout seul sous
   un build avancé, le Noyau tient assez pour rester un vrai choix jusqu'au bout.

   `radius: 52` : nettement plus gros que le Bloc, pour que la dureté se LISE
   avant même le premier tir — un joueur doit pouvoir juger « celui-là, je ne le
   casserai pas à temps » à sa seule silhouette.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineObstacle({
  id: 'astero-noyau',
  radius: 52,
  hp: 240,
  destructible: true,
  score: 90,
});
